<template>
  <div>
    <el-form
      :inline="true"
      :rules="rules"
      :model="addzzh"
      class="my-form-template"
      label-width="120px"
      ref="addform"
      label-position="right"
      v-loading="loading"
    >
      <el-form-item label="团队名称" prop="mechanName" class="less">
        <el-input v-model.trim="addzzh.mechanName" :maxlength="50" placeholder="请输入团队名称"></el-input>
      </el-form-item>
      <el-form-item label="上级团队" prop="parentMechanId" :rules="$tools.formRule.required('请选择上级团队', 'change')" class="less">
        <merchantTree v-model="addzzh.parentMechanId" :disabled="true" :params="{ levels: [1, 2] }" @change="changeOrg"></merchantTree>
      </el-form-item>
      <el-form-item
        label="商务"
        prop="busserId"
        :rules="$tools.formRule.required('请选择商务', 'change')"
        v-if="busserList && busserList.length && userinfo.isXbbMechan == 1"
        class="less"
      >
        <el-select v-model="addzzh.busserId" placeholder="请选择">
          <el-option v-for="(item, key) in busserList" :key="key" :disabled="!item.enable" :label="item.userName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="name" class="less">
        <el-input v-model.trim="addzzh.name" :maxlength="20" placeholder="请输入联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="联系手机号" prop="mobile" class="less">
        <el-input v-model="addzzh.mobile" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人证件号"
        prop="idCardNo"
        :rules="$tools.formRule.required('请输入身份证')"
        v-if="addzzh.mechanUserType == 2 || addzzh.mechanUserType == 3"
        class="less"
      >
        <el-input v-model.trim="addzzh.idCardNo" placeholder="请输入身份证"></el-input>
      </el-form-item>
      <el-form-item
        label="执业证编号"
        prop="certificateNo"
        :rules="$tools.formRule.required('请输入执业证编号')"
        v-if="addzzh.mechanUserType == 2 || addzzh.mechanUserType == 3"
        class="less"
      >
        <el-input v-model.trim="addzzh.certificateNo" placeholder="请输入执业证编号"></el-input>
      </el-form-item>
      <el-form-item label="费率模板" class="less">
        <el-select v-model="addzzh.commissonTemplateCode" placeholder="请选择" filterable>
          <el-option :label="item.name" :value="item.code" v-for="(item, index) in feeTemplateList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登录账号" prop="account" class="less">
        <el-input style="text-align: center" v-model="addzzh.account" placeholder="请输入登录账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" class="less" v-if="showPwd || !id" style="margin-bottom: 10px">
        <el-input :type="showPass ? 'text' : 'password'" v-model.trim="addzzh.password" autocomplete="new-password" placeholder="请输入登录密码">
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-hide.png" @click="showPass = !showPass" v-if="!showPass"/>
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-show.png" @click="showPass = !showPass" v-else/>
        </el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword" class="less" v-if="showPwd || !id" style="margin-bottom: 10px">
        <el-input :type="showConfirmPass ? 'text' : 'password'" v-model.trim="addzzh.confirmPassword" autocomplete="new-password" placeholder="请输入登录密码">
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-hide.png" @click="showConfirmPass = !showConfirmPass" v-if="!showConfirmPass"/>
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-show.png" @click="showConfirmPass = !showConfirmPass" v-else/>
        </el-input>
      </el-form-item>
      <div class="text3" v-if="showPwd || !id">注：新密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
      <el-form-item label="登录密码" class="less" v-if="id">
        <el-button type="primary" size="small" v-if="!showPwd" @click="showPwd = true">修改密码</el-button>
        <el-button type="primary" size="small" v-if="showPwd" @click="showPwd = false">隐藏密码</el-button>
      </el-form-item>
      <el-form-item label="状态" class="less">
        <el-switch v-model="addzzh.useStatus" active-text="启用" active-value="1" inactive-text="禁用" inactive-value="0"> </el-switch>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button type="primary" plain @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="addzzhfclick('addform')" :loading="btnloading">保存</el-button>
    </div>
  </div>
</template>
<script>
import merchantTree from '@/components/merchantTree.vue';
export default {
  components: {
    merchantTree
  },
  data: () => ({
    loading: false,
    showPwd: false,
    showPass: false,
    showConfirmPass: false,
    all: {}, // 字典对象
    busserList: [], // 商务列表
    feeTemplateList: [], // 产品模板列表
    btnloading: false, // 按钮
    addzzh: {
      //新增子团队请求对应
      id: '',
      account: '',
      mobile: '', //手机号
      name: '', // 联系人
      mechanName: '', // 团队名称
      parentMechanId: '',//上级团队
      busserId: '', // 商务
      password: '', // 登录密码
      confirmPassword: '', // 确认密码
      idCardNo: '', // 身份证
      certificateNo: '', // 执业证编号
      useStatus: '1', // 状态
      commissonTemplateCode: '',
      level: '', // 新增团队级别
      productTemplateCode: '', //产品模板code
    },
    rules: {
      //新增子团队弹框input校验
      mechanName: [
        {
          required: true,
          message: '请输入团队名称',
          trigger: 'blur',
        },
      ],
      account: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
      name: [
        {
          required: true,
          message: '请输入联系人姓名',
          trigger: 'blur',
        },
      ],
      password: [
        {
          required: true,
          message: '请输入登录密码',
          trigger: 'blur',
        },
        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
      ],
      confirmPassword: [
        {
          required: true,
          message: '请输入登录密码',
          trigger: 'blur',
        },
        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
      ],
      mobile: [
        {
          pattern: /^1[1023456789]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur',
        },
      ],
    },
    id: '', //团队id
    userinfo: {},
  }),
  created() {
    // 当前账号数据
    this.userinfo = this.$tools.getLocal('userinfo')
  },
  methods: {
    changeOrg({ level }) {
      this.$set(this.addzzh, 'commissonTemplateCode', '')
      this.getFeeTemplate()
      this.addzzh.level = Number(level) + 1;
    },
    // 查询所有费率模板
    getFeeTemplate() {
      this.$http({
        url: '/master/commissonTemplate/read/all',
        type: 'PUT',
        params: {
          type: '1',
          mechanId: this.addzzh.parentMechanId
        },
      }).then((res) => {
        this.feeTemplateList = res.data
      })
    },
    async open({ id, parentMechanId }) {
      this.id = ''
      this.showPwd = false
      this.showPass = false
      this.showConfirmPass = false
      this.addzzh = {
        //新增子团队请求对应
        account: '',
        id: '',
        mobile: '', //手机号
        name: '', // 联系人
        mechanName: '', // 团队名称
        parentMechanId: '',
        busserId: '', // 商务
        password: '', // 登录密码
        confirmPassword: '', // 确认密码
        idCardNo: '', // 身份证
        certificateNo: '', // 执业证编号
        useStatus: '1', // 状态
        level: '', // 新增团队级别
        productTemplateCode: '', //产品模板code
      }
      this.$refs['addform'] && this.$refs['addform'].clearValidate()
      this.getState()
      // 如果有id就是编辑，获取当前团队的详情信息
      if (id) {
        this.id = id
        await this.getMechanDetail()
      } else if (parentMechanId) {
        this.$set(this.addzzh, 'parentMechanId', parentMechanId);
      }
      this.getFeeTemplate();
    },
    //获取状态
    getState() {
      this.$tools.getall(this.setAll)
    },
    setAll(data) {
      this.all = data
      //isXbbMechan, 1是新保保渠道，0不是新保保渠道
      if (this.userinfo.isXbbMechan == 1) {
        // 只有新保保渠道有商务列表选项
        this.getBusserList()
      }
    },

    // 根据银行账号查询所属银行名称
    getBankInfo(num) {
      if (!num) {
        return
      }
      this.$http({
        url: '/insure/getBankInfo?cardNumber=' + num,
        type: 'post',
      })
        .then((data) => {
          if (data.data.bankName) {
            this.addzzh.bankType = data.data.bankName
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取商务列表
    getBusserList() {
      this.$http({
        url: '/master/mechan/queryBusserList',
        type: 'PUT',
        params: {},
      }).then((data) => {
        this.busserList = data.data
        this.busserList.sort((a, b) => a.enable - b.enable)
      })
    },
    // 获取团队详情
    getMechanDetail() {
      return new Promise(resolve => {
        this.loading = true
        this.$http({
          url: '/master/level2/account/detail',
          type: 'get',
          params: {
            mechanId: this.id,
          },
        })
          .then((res) => {
            this.loading = false
            res.data.useStatus = res.data.useStatus.toString()
            if (res.data.bankType) {
              res.data.bankType = res.data.bankType.toString()
            }
            if (res.data.mechanUserType) {
              res.data.mechanUserType = res.data.mechanUserType.toString()
            }
            this.addzzh = res.data
            resolve(res.data)
          })
          .catch((e) => {
            this.loading = false
          })
      })
    },
    //新增子团队保存
    addzzhfclick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addzzh.password != this.addzzh.confirmPassword) {
            return this.$message.error('2次输入密码不一致')
          }
          this.btnloading = true
          this.saveForm(this.addzzh)
        } else {
          this.btnloading = false
          this.$message.error('请输入正确的信息')
        }
      })
    },
    //新增子团队接口
    saveForm(obj) {
      this.$http({
        url: '/master/subAccount/updateMechanSubAccount',
        type: 'put',
        params: obj,
      })
        .then((data) => {
          this.btnloading = false
          if (data.httpCode == 200) {
            this.showPwd = false
            this.$emit('close');
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                // 刷新组织关系树
                this.$bus.$emit('refreshTree')
              },
            })
          }
        })
        .catch((e) => {
          this.btnloading = false
        })
    },
  },
}
</script>
<style lang='scss' scoped>
.my-form-template {
  &::v-deep {
    .el-form-item.is-error .el-input__validateIcon {
      display: none !important;
    }
    .el-form-item .el-input__validateIcon {
      display: none !important;
    }
  }
  .el-form-item {
    margin-bottom: 30px;
  }

  // .password-none {
  //   &::v-deep {
  //     .el-input__inner {
  //       -webkit-text-security: disc !important;
  //       -moz-text-security: disc !important;
  //     }
  //   }
  // }
  .text3 {
    font-weight: 400;
    line-height: 30px;
    text-align: left;
    margin-bottom: 30px;
    margin-left: 30px;
    font-size: 12px;
    color: #999999;
  }
  
  &::v-deep {
    .show-pass {
      cursor: pointer;
      width: 20px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
    }
  }
}
</style>